import memoizeOne from 'memoize-one';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var identity = function identity(arg) {
  return arg;
};

var makeEncDecFromFn = function makeEncDecFromFn(fn) {
  return {
    encode: memoizeOne(function (data) {
      return fn(undefined, data);
    }),
    decode: memoizeOne(function (str) {
      return fn(str, undefined);
    })
  };
};

var makeEncDecFromObj = function makeEncDecFromObj(obj) {
  return {
    encode: obj.encode ? memoizeOne(obj.encode) : identity,
    decode: obj.decode ? memoizeOne(obj.decode) : identity
  };
};

var makeEncDec = function makeEncDec(arg) {
  if (typeof arg === 'function') {
    return makeEncDecFromFn(arg);
  } else if (typeof arg === 'object') {
    var qp = {};

    var encode = arg.encode,
        decode = arg.decode,
        others = _objectWithoutPropertiesLoose(arg, ["encode", "decode"]);

    var global = makeEncDecFromObj(arg);
    var memoized = {};

    for (var k in others) {
      if (typeof others[k] === 'function') {
        memoized[k] = makeEncDecFromFn(others[k]);
      } else if (typeof others[k] === 'object') {
        memoized[k] = makeEncDecFromObj(others[k]);
      }
    }

    qp.encode = memoizeOne(function (data) {
      var out = global.encode(data);

      for (var _k in memoized) {
        out[_k] = memoized[_k].encode(data[_k]);
      }

      return out;
    });
    qp.decode = memoizeOne(function (data) {
      var out = global.decode(data);

      for (var _k2 in memoized) {
        out[_k2] = memoized[_k2].decode(data[_k2]);
      }

      return out;
    });
    return qp;
  } else {
    return {
      encode: function encode(arg) {
        return arg;
      },
      decode: function decode(arg) {
        return arg;
      }
    };
  }
};

export { _extends as _, makeEncDec as m };